import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
import axios from "axios";
import getfile from "../../utils/getFile";
import LoadingBar from "../LoadingBar";
import { useLiffProfile } from "../../context/LiffProfileContext";
import MissionsCard from "./missionsCard";
import TermsAndConditions from "./termsAndConditions";
import missionBiggyBear from "../../assets/images/mission-biggy-bear.0da057a.png";

const MissionsDetail = () => {
  const { t, i18n } = useTranslation();
  const { authToken, userId } = useLiffProfile();
  const { id } = useParams();
  const navigate = useNavigate();
  const [missionData, setMissionData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [imageUrls, setImageUrls] = useState({});

  useEffect(() => {
    setLoading(true);
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/clm-missions/${id}`;
    const clientAuth = process.env.REACT_APP_CLIENT_AUTH;

    axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "X-Client-Auth": clientAuth,
          "x-user-id": userId,
          "Accept-Language": i18n.language.toUpperCase(),
        },
      })
      .then(async (response) => {
        if (response.data && response.data.data) {
          const mission = response.data.data;
          setMissionData(mission);

          if (mission.image) {
            try {
              const url = await getfile(mission.image, authToken, userId);
              setImageUrls({ [mission.id]: url });
            } catch (err) {
              console.error("Failed to load image", err);
            }
          }
        } else {
          setError("No data found for this mission.");
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const onReward = (e, rewardType) => {
    //clearMissionDetailUrlOrigin();
    e.preventDefault();

    if (rewardType === "BigPoint") {
      navigate("/my-bigpoint");
    } else {
      navigate("/my-coupons");
    }
  };

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <LoadingBar loading={true} label="Loading..." />
      </div>
    );
  }

  if (error) return <p className="text-center text-red-500">{error}</p>;

  const isExpiredMission =
    (missionData?.dayToExpire ?? -1) < 0 || missionData?.status === "E";

  return (
    <>
      <div className="w-full flex flex-col gap-y-4">
        <div className="h-screen flex flex-col bg-secondary-background">
          <ProfileWithBackButtonHeader className="bg-primary" />
          <div className="w-full flex flex-col px-2 py-2 bg-secondary-background bg-primary">
            <h2 className="text-3xl pt-3 pb-3 font-bold">
              {t("big_c_mission")}
            </h2>
          </div>
          <div className="flex-grow overflow-y-auto p-4">
            {missionData ? (
              <>
                <MissionsCard
                  item={missionData}
                  missionsInCategory={[missionData]} // ต้องใส่ array เพราะใน Card คำนวณ progress ต้องใช้ array
                  imageUrls={imageUrls}
                  isExpiredMission={isExpiredMission}
                  templateDetail={true}
                  actionLink={`#`}
                  showDescription={true}
                />

                <TermsAndConditions
                  latestMission={missionData}
                  longDescription={missionData.longDescription}
                />
              </>
            ) : (
              <div className="w-full h-full flex flex-col items-center justify-center">
                <img
                  src={missionBiggyBear}
                  alt="No Missions"
                  className="w-40 mt-10"
                />
                <div className="mt-5 text-center">
                  <span className="font-semibold text-22">
                    {t("mission_empty_header")}
                  </span>
                  <br />
                  <span className="font-normal">{t("mission_empty_desc")}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {missionData.isCompleted &&
      missionData.employeeMission !== "1" &&
      !["Discount_BigC", "Discount_Supplier"].includes(
        missionData.rewardType
      ) ? (
        <div className="bg-white w-full max-w-md h-15 p-5 z-[888] justify-items-center fixed bottom-0">
          <button
            className="w-[250px] bg-green-600 text-white p-3  rounded-full hover:bg-green-700"
            onClick={(e) => onReward(e, missionData.rewardType)}
          >
            <span>{t("view_reward")}</span>
          </button>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default MissionsDetail;
